import Reflux from 'reflux';

export default Reflux.createActions({
	/** send data to storage
	 * @param{String} data data sent to storage. this is not modify and has to comply with data accepted by the server, i.e. beeing coded in base64
	 */
	send: {},
	/** fetch data from storage
	 * @param{String} id server ID of data to fetch
	 */
	fetch: {}
});
